// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3AN0K","content":"styles_content__wiaSS","selectAll":"styles_selectAll__1s4jt"};